// // import { Navigate } from "react-router-dom";
// // import { useAuth } from "../context/AuthContext";

// // export default function ProtectedRoute({ children }) {
// //   const { authUser, authChecked } = useAuth();

// //   if (!authChecked) return null;

// //   if (!authUser) {
// //     return <Navigate to="/" replace />;
// //   }

// //   return children;
// // }

// import { Navigate } from "react-router-dom";
// import { useAuth } from "../context/AuthContext";

// export default function ProtectedRoute({ children, allow }) {
//   const { authUser } = useAuth();

//   // not logged in
//   if (!authUser) {
//     return <Navigate to="/" replace />;
//   }

//   // detect role safely
//   const role =
//     authUser?.role ||
//     authUser?.user_role ||
//     authUser?.is_admin ||
//     authUser?.group;

//   const isAdmin =
//     role === "admin" ||
//     role === "ADMIN" ||
//     role === 1 ||
//     role === true;

//   // authorization check
//   if (allow === "admin" && !isAdmin) {
//     return <Navigate to="/library" replace />;
//   }

//   if (allow === "user" && isAdmin) {
//     return <Navigate to="/Admin" replace />;
//   }

//   return children;
// }


import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children, allow }) {
  const { authUser, authChecked } = useAuth();

  // ⛔ Wait until auth restore is finished
  if (!authChecked) {
    return null; // or return <div>Loading...</div>
  }

  // 🚫 Not logged in
  if (!authUser) {
    return <Navigate to="/" replace />;
  }

  // ✅ Role detection
  const role =
    authUser?.role ||
    authUser?.user_role ||
    authUser?.is_admin ||
    authUser?.group;

  const isAdmin =
    role === "admin" ||
    role === "ADMIN" ||
    role === 1 ||
    role === true;

  // 🔐 Authorization
  if (allow === "admin" && !isAdmin) {
    return <Navigate to="/library" replace />;
  }

  if (allow === "user" && isAdmin) {
    return <Navigate to="/Admin" replace />;
  }

  return children;
}